import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Scheduler.SchedulerMonth', {
    everyMonth: 'Every month',
    everyMonthsStartingIn: '<b>[ N ]</b> month(s) starting in <b>[ Month ]</b>',
    specificMonth: 'Specific month (choose one or many)',
    everyMonthBetween: '<b>[ Month ]</b> and <b>[ Month ]</b>',
    every: 'Every ',
    startingMonth: 'month(s) starting in',
    selectMonths: 'Select months',
    monthBetween: 'Every month between ',
    and: 'and ',
    monthScheduler: 'Month scheduler',
});
